import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import validator from 'validator';
import Cookies from 'js-cookie';

import api from '../../services/api';

import 'bootstrap/scss/bootstrap.scss';
import './style/form.scss';

import { ReactComponent as IconCar } from './images/red-car.svg';
import loader from '../../img/icon-loading.gif';

export default class FormUserLogin extends Component {
	formDefaults = {
		email: {
			value: '', isValid: true, message: '', input: 'email',
		},
		password: {
			value: '', isValid: true, message: '', input: 'senha',
		},
		formInvalid: false,
	};

	showPassword = {
		typeAttrPassword: 'password',
		classIconPassword: '',
	};

	requestAPI = {
		responseApiLoginAccount: '',
		classResponse: '',
		fieldDisable: false,
		token: '',
	};

	state = {
		...this.formDefaults,
		...this.showPassword,
		...this.requestAPI,
	};

	createUser = () => {
		const {
			email,
			password,
		} = this.state;

		const data = {
			email: email.value,
			password: password.value,
		};

		const that = this;

		that.setState({
			responseApiLoginAccount: '',
			fieldDisable: true,
		});

		api.post('/login', JSON.stringify(data))
			.then((response) => {
				const tokenGearBox = response.data.data.attributes.token;
				that.setState({
					responseApiLoginAccount: 'Usuário logado com sucesso!',
					classResponse: 'success',
					token: tokenGearBox,
				});
				const linkHistory = this.getUriParamValue('history');
				window.location.href = linkHistory || '/backoffice';
			})
			.catch((e) => {
				that.setState({
					responseApiLoginAccount: e.response || 'Falha ao logar, tente mais tarde.',
					classResponse: 'danger',
					fieldDisable: false,
				});
			})
			.finally(() => {
				const { token } = this.state;
				Cookies.set('Token', token);
				localStorage.setItem('loggedFrom', 'login');
			});
	};

	uriGetParams = () => {
		const queryDict = {};
		window.location.search.substr(1).split('&')
			.forEach((item) => {
				queryDict[item.split('=')[0]] = item.split('=')[1];
			});
		return queryDict;
	};

	getUriParamValue = (key) => {
		const uriParams = this.uriGetParams();
		return uriParams[key] || '';
	};

	onChange = (e) => {
		const state = {
			...this.state,
			[e.target.name]: {
				...this[e.target.name],
				value: e.target.value,
			},
		};

		this.setState(state);
	};

	onSubmit = (e) => {
		e.preventDefault();
		this.resetValidationStates();
		if (this.formIsValid()) {
			this.createUser();
		}
	};

	formIsValid = () => {
		const {
			email,
			password,
		} = this.state;

		const fields = [email, password];
		let isGood = true;

		this.resetFields(fields);

		if (!validator.isEmail(email.value)) {
			email.isValid = false;
			email.message = '* O email digitado não é válido.';
			isGood = false;
		}

		fields.map((field) => {
			if (validator.isEmpty(field.value)) {
				field.isValid = false;
				field.message = `* O campo ${field.input} não pode ser vazio.`;
				isGood = false;
			}

			return field;
		});

		if (!isGood) {
			this.setState({
				email,
				password,
				formInvalid: true,
			});
		}

		return isGood;
	};

	resetFields = (fields) => {
		fields.map((field) => {
			field.isValid = false;
			field.message = '';

			return field;
		});
	};

	resetValidationStates = () => {
		const state = JSON.parse(JSON.stringify(this.state));

		const hasBarProperty = Object.prototype.hasOwnProperty.call(state, 'isValid');

		Object.keys(state).map((key) => {
			if (hasBarProperty) {
				state[key].isValid = true;
				state[key].message = '';
			}
			return state[key];
		});

		return this.setState(state);
	};

	toggleEnabledPassword(icon) {
		const { classIconPassword } = this.state;

		this.setState({ classIconPassword: '', typeAttrPassword: 'password' });

		if (icon === 'icon-password' && classIconPassword === '') {
			this.setState({ classIconPassword: 'fa-eye-slash', typeAttrPassword: 'text' });
		}
	}

	render() {
		const {
			email,
			password,
			fieldDisable,
			typeAttrPassword,
			classIconPassword,
			classResponse,
			responseApiLoginAccount,
			formInvalid,
		} = this.state;

		const emailGroupClass = classNames('form-group',
			{ 'has-error': !email.isValid });
		const passwordGroupClass = classNames('form-group',
			{ 'has-error': !password.isValid });

		return (
			<Fragment>
				<div className="d-flex justify-content-center">
					<IconCar width="10%" />
				</div>

				<form className="form-signin">
					<div className="content-form">
						<div className={`form-group ${emailGroupClass}`}>
							<input
								type="email"
								name="email"
								className={`form-control toggle-password ${(formInvalid && email.message !== '') ? 'is-invalid' : ''}`}
								placeholder="Email"
								value={email.value}
								onChange={this.onChange}
								disabled={fieldDisable}
							/>

							<div className="help-block">{email.message}</div>
						</div>

						<div className={`form-group  ${passwordGroupClass}`}>
							<div className="container-password">
								<input
									type={typeAttrPassword}
									name="password"
									className={`form-control remove-icon ${(formInvalid && password.message !== '') ? 'is-invalid' : ''}`}
									placeholder="Password"
									value={password.value}
									onChange={this.onChange}
									disabled={fieldDisable}
								/>

								<span
									role="button"
									tabIndex="-1"
									toggle="#password-field" 
									className={`fa fa-fw fa-eye field-icon toggle-password ${classIconPassword}`}
									onClick={this.toggleEnabledPassword.bind(this, 'icon-password')}
									onKeyDown={this.toggleEnabledPassword.bind(this, 'icon-password')}
								/>

								<div className="help-block">{password.message}</div>
							</div>
						</div>

						<div className="container-access-form-login">
							<label className="container-checkbox" htmlFor="term-agree">
								Manter-me conectado.
								<input
									type="checkbox"
									name="term"
									className="form-control"
									id="term-agree"
								/>

								<span
									className="checkmark"
									role="checkbox"
									aria-checked="false"
									tabIndex="0"
									aria-labelledby="term-agree"
								/>
							</label>

							<div className="forget-password">
								<Link to="/">Esqueceu sua senha?</Link>
							</div>
						</div>
					</div>

					<button
						className="btn btn-default btn-continue"
						type="submit"
						onClick={this.onSubmit.bind(this)}
						disabled={fieldDisable}
					>
						{fieldDisable ? <img src={loader} alt="" /> : 'Continuar'}
					</button>
				</form>

				{classResponse !== ''
					? (
						<div
							className={`response-create-account mt-3 alert alert-${classResponse}`}
						>
							{responseApiLoginAccount}
						</div>
					)
					: ''}
			</Fragment>
		);
	}
}
